export const NAME_ID_POLICY_FORMAT_VALUES = [
  'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
  'urn:oasis:names:tc:SAML:1.1:nameid-format:unspecified',
  'urn:oasis:names:tc:SAML:1.1:nameid-format:X509SubjectName',
  'urn:oasis:names:tc:SAML:1.1:nameid-format:WindowsDomainQualifiedName',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:transient',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:kerberos',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:entity',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:encrypted',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:persistent-pseudonym',
  'urn:oasis:names:tc:SAML:2.0:nameid-format:uuid',
];
